// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fancy-text .value-undefined {
  opacity: 0.4;
  font-style: italic;
}
.fancy-text .value-null {
  opacity: 0.4;
}
.fancy-text ul.value-object {
  list-style: none;
  padding: 0;
}
.fancy-text ul.value-object li {
  margin: 4px 0;
  overflow-y: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fancy-text .value-object-key {
  font-weight: bold;
  margin-right: 4px;
  color: rgba(0, 0, 0, 0.5);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nackle/studio-tools/dist/components/fancy-text/fancy-text.less"],"names":[],"mappings":"AAAA;EAGQ,YAAA;EACA,kBAAA;AADR;AAHA;EAQQ,YAAA;AAFR;AANA;EAYQ,gBAAA;EACA,UAAA;AAHR;AAVA;EAgBY,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAhBA;EAwBQ,iBAAA;EACA,iBAAA;EACA,yBAAA;AALR","sourcesContent":[".fancy-text {\n\n    .value-undefined {\n        opacity: .4;\n        font-style: italic;\n    }\n\n    .value-null {\n        opacity: .4;\n    }\n\n    ul.value-object {\n        list-style: none;\n        padding: 0;\n\n        li {\n            margin: 4px 0;\n            overflow-y: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n    }\n\n    .value-object-key {\n        font-weight: bold;\n        margin-right: 4px;\n        color: rgba( 0, 0, 0, .5 );\n    }\n}\n\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
